import { environment } from '../../environments/environment';
export class API {
  static API_URL = environment.apiUrl;
  // static API_URL = 'https://cybersale-test.five9.vn/api';
  static API_URL_COMMON = environment.apiUrl;
  static CALLFUNC = API.API_URL_COMMON + 'admin/callfunc';
  static VIEW = API.API_URL_COMMON + 'admin/view';
  static CREATE = API.API_URL_COMMON + 'admin/create';
  static READ = API.API_URL_COMMON + 'admin/read';
  static FINDALLDATA = API.API_URL_COMMON + 'admin/findalldata';
  static FINDONEDATA = API.API_URL_COMMON + 'admin/findonedata';
  static ADMIN_TABLE_RESET_DEFAULT = API.API_URL_COMMON + 'admin/resetadmintable';
  static GETFK = API.API_URL_COMMON + 'admin/getfkmul';
  static EXCEL = API.API_URL_COMMON + 'admin/exportexcel';
  static UPDATE_ATTRIBUTE = API.API_URL_COMMON + 'admin/updateattribute';
  static UPDATE_ATTRIBUTE_MANY = API.API_URL_COMMON + 'admin/updateattributemany';
  static UPDATE = API.API_URL_COMMON + 'admin/update';
  static UPDATEALL = API.API_URL_COMMON + 'admin/updateall';
  static DELETE = API.API_URL_COMMON + 'admin/delete';
  static DELETEALL = API.API_URL_COMMON + 'admin/deleteall';
  static UPDATE_FILTER_DEFAULT = API.API_URL_COMMON + 'admin/updatefilterdefault';
  static HEADER_ROLE = API.API_URL_COMMON + 'admin/headerrole';
  static SYSTEM_SETTING = API.API_URL_COMMON + 'admin/systemsetting';
  static SYSTEM_SETTING_UPDATE = API.API_URL_COMMON + 'admin/configsetting';
  static USER_COLUMN = API.API_URL_COMMON + 'admin/usercolumn';
  static SYSTEM_SEND_MAIL = API.API_URL_COMMON + 'admin/sendtestmail';
  static LIST_ROLE = API.API_URL_COMMON + 'admin/listrole';
  static LOGIN = API.API_URL_COMMON + 'auth';
  static LOGIN_FROM_E_LEARNING = API.API_URL_COMMON + 'sync/elearning/token_exchange';
  static AUTHEN = API.API_URL_COMMON + 'auth';
  static LOGOUT = API.API_URL_COMMON + 'token/revoke';
  static ROLE = API.API_URL_COMMON + 'role';



  static INFORMATION = API.API_URL_COMMON + 'dashboard';
  static CHANGEPASSWORD = API.API_URL_COMMON + 'changepassword';
  static FORGOTPASSWORD = API.API_URL_COMMON + 'users/{email_address}/forget_password';
  static RESETPASSWORD = API.API_URL_COMMON + 'users/{email_address}/reset_password';
  static CHECK_TOKEN_RESET = API.API_URL_COMMON + 'checktokenreset?access_token={access_token}';
  static COUNT_CUSTOMER = API.API_URL_COMMON + 'customer/userassign?user_id={user_id}';

  static SCHOOL_ACTIVE_INACTIVE = API.API_URL_COMMON + 'schools/?school_id[in]=';
  static MENTOR_ACTIVE_INACTIVE = API.API_URL_COMMON + 'mentors/?username[in]=';
  static CREATE_SCHOOL = API.API_URL_COMMON + "schools";
  static GET_SCHOOL_LIST = API.API_URL_COMMON + "admin_school_list";
  static GET_MENTOR_LIST = API.API_URL_COMMON + "admin_mentor_list";
  static CREATE_MENTOR = API.API_URL_COMMON + "mentors";
  static GET_MENTOR = API.API_URL_COMMON + "mentors/{email_address}";
  static GET_USER_INFO = API.API_URL_COMMON + "users/{username}";
  static UPLOAD_FILES = API.API_URL_COMMON + "files";
  static GET_FILES = API.API_URL_COMMON + "files";
  static CREATE_STUDENT = API.API_URL_COMMON + "students";
  static GET_ACADEMIC_YEAR = API.API_URL_COMMON + "academic_years";
  static CREATE_ACADEMIC_YEAR = API.API_URL_COMMON + "academic_years";
  static UPDATE_DEFAULT_ACADEMIC_YEAR = API.API_URL_COMMON + "academic_years";
  static CREATE_STUDENT_FILES = API.API_URL_COMMON + "student_files";
  static CREATE_STUDENT_ATTENDANCE = API.API_URL_COMMON + "attendance";
  static GET_INDICATOR_DATA = API.API_URL_COMMON + "label_groups";
  static CREATE_ACTIVITIES = API.API_URL_COMMON + "activities";
  static CREATE_BEHAVIOR_FORM = API.API_URL_COMMON + "behavior_form";
  static CREATE_GROUP_FILES = API.API_URL_COMMON + "group_files";
  static CREATE_ACTIVITIES_FILES = API.API_URL_COMMON + "activity_files";
  static CREATE_INDIVIDUAL_CONTACT = API.API_URL_COMMON + "add_individual_contact";
  static CREATE_INDIVIDUAL_MENTORING = API.API_URL_COMMON + "add_individual_mentoring";


  static GET_INDICATOR_GROUPS = API.API_URL_COMMON + "label_group_list";
  static GET_INDICATOR_LABELS = API.API_URL_COMMON + "labels";
  static GET_INDICATOR_VALUES = API.API_URL_COMMON + "label_values";
  static CRUD_INDICATOR_GROUPS = API.API_URL_COMMON + "label_groups";
  static BEHAVIOR_FORM_DETAILS = API.API_URL_COMMON + "behavior_form_details";

  static GET_REPORT_REMARKS = API.API_URL_COMMON + "remark_list";
  static CREATE_ATTENDANCES = API.API_URL_COMMON + "attendances";
  static GET_ATTENDANCES = API.API_URL_COMMON + "attendances";
  static OUTSTANDING_FORM = API.API_URL_COMMON + "outstanding_forms/?keyword={keyword}";

  static GET_REPORT_MONTH_MENTOR_LOGIN = API.API_URL_COMMON + "month_mentor_login";
  static GET_REPORT_MONTH_GROUP_CREATED = API.API_URL_COMMON + "month_group_created";
  static GET_REPORT_MONTH_ACTIVITY_ADDED = API.API_URL_COMMON + "month_activity_added";

  static STUDENT_INTERVIEWS = API.API_URL_COMMON + "student_interviews";
  static STUDENT_INTERVIEW_ANSWERS = API.API_URL_COMMON + "student_interview_answers";
  static STUDENT_INTERVIEW_QUESTIONS = API.API_URL_COMMON + "student_interview_questions";
  static STUDENT_INTERVIEW_TEMPLATES = API.API_URL_COMMON + "student_interview_templates";

  static TEACHER_INTERVIEWS = API.API_URL_COMMON + "teacher_interviews";
  static TEACHER_INTERVIEW_ANSWERS = API.API_URL_COMMON + "teacher_interview_answers";
  static TEACHER_INTERVIEW_QUESTIONS = API.API_URL_COMMON + "teacher_interview_questions";
  static TEACHER_INTERVIEW_TEMPLATES = API.API_URL_COMMON + "teacher_interview_templates";

  static STUDENT_QUESTIONNAIRES = API.API_URL_COMMON + "student_questionnaires";
  static STUDENT_QUESTIONNAIRE_ANSWERS = API.API_URL_COMMON + "student_questionnaire_answers";
  static STUDENT_QUESTIONNAIRE_QUESTIONS = API.API_URL_COMMON + "student_questionnaire_questions";
  static STUDENT_QUESTIONNAIRE_TEMPLATES = API.API_URL_COMMON + "student_questionnaire_templates";

  static TEACHER_QUESTIONNAIRES = API.API_URL_COMMON + "teacher_questionnaires";
  static TEACHER_QUESTIONNAIRE_ANSWERS = API.API_URL_COMMON + "teacher_questionnaire_answers";
  static TEACHER_QUESTIONNAIRE_QUESTIONS = API.API_URL_COMMON + "teacher_questionnaire_questions";
  static TEACHER_QUESTIONNAIRE_TEMPLATES = API.API_URL_COMMON + "teacher_questionnaire_templates";

  static PRINCIPAL_QUESTIONNAIRES = API.API_URL_COMMON + "principal_questionnaires";
  static PRINCIPAL_QUESTIONNAIRE_ANSWERS = API.API_URL_COMMON + "principal_questionnaire_answers";
  static PRINCIPAL_QUESTIONNAIRE_QUESTIONS = API.API_URL_COMMON + "principal_questionnaire_questions";
  static PRINCIPAL_QUESTIONNAIRE_TEMPLATES = API.API_URL_COMMON + "principal_questionnaire_templates";

  static SCHOOL_REPORT_PROGRAM_SUMMARY = API.API_URL_COMMON + "program_summary";
  static STUDENT_QUESTIONNAIRE_SUMMARY = API.API_URL_COMMON + "student_questionnaire_data_summary";
  static TEACHER_QUESTIONNAIRE_SUMMARY = API.API_URL_COMMON + "teacher_questionnaire_data_summary";
  static PRINCIPAL_QUESTIONNAIRE_DATA_SUMMARY = API.API_URL_COMMON + "principal_questionnaire_data_summary";
  static STUDENT_BEHAVIORAL_CHANGE_SUMMARY = API.API_URL_COMMON + "student_behavioral_change";
  static STUDENT_FEEDBACK_SUMMARY = API.API_URL_COMMON + "student_feedback";
  static TEACHER_FEEDBACK_SUMMARY = API.API_URL_COMMON + "teacher_feedback";
  static INDIVIDUAL_MENTORING_SUMMARY = API.API_URL_COMMON + "individual_mentoring";
  static SMALL_GROUP_SUPPORT_SUMMARY = API.API_URL_COMMON + "small_group_support";
  static ACTIVITY_SUMMARY = API.API_URL_COMMON + "activity_data_summary";

  static GROUPS_BY_ACTIVITY_TIER_AND_DATES =  API.API_URL_COMMON + "groups_by_activity_tier_and_dates";
  static STUDENT_LIST_FILTERED = API.API_URL_COMMON + "student_list_export";
  static STAGES_OF_DEVELOPMENT_STUDENT_COUNT = API.API_URL_COMMON+ "student_summary_stages_of_development";
  static STAGES_OF_DEVELOPMENT_TIME_INTERVAL = API.API_URL_COMMON+ "student_summary_stages_of_development_time_interval";
  static STUDENTS_BY_DATE_AND_SCHOOL = API.API_URL_COMMON+ "students_by_date_and_school"
  static SESSIONS_COUNT = API.API_URL_COMMON + "school_review_sessions"
  static FORMS_AND_CLASSES = API.API_URL_COMMON + "forms_and_classes"
  static I_MENTORING_REVIEW = API.API_URL_COMMON + "individual_mentoring_review"
  static G_INTERVENTIONS_REVIEW = API.API_URL_COMMON + "group_interventions";
  static SCHOOL_REVIEW_STUDENT_SUMMARY = API.API_URL_COMMON + "school_review_student_summary";
  static SCHOOL_REVIEW_IMPROVED_STUDENTS = API.API_URL_COMMON + "school_review_improved_students";
}



// WEBPACK FOOTER //
// ./src/app/config/api.ts